import React from 'react';
import { Box, Button } from '@mui/material';
import logo from '../images/Familiprix_logo.svg';
import Language from './Language';
import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined';

const Header = (props: {
  fullNavbar: boolean;
  navbarHandler: (value: boolean | ((prevVar: boolean) => boolean)) => void;
}): JSX.Element => {
  return (
    <>
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <img style={{ top: '5px', position: 'relative' }} src={logo} alt="Familiprix" />
      </Box>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Box sx={{ display: 'flex' }}>
            <Button onClick={() => props.navbarHandler(!props.fullNavbar)}>
              <ArrowDropDownCircleOutlinedIcon fontSize="large"></ArrowDropDownCircleOutlinedIcon>
            </Button>
            <Box sx={{ paddingRight: '16px' }}>
              <Box
                sx={{ width: '100%', top: '5px', position: 'relative' }}
                component="img"
                src={logo}
                alt="Familiprix"></Box>
            </Box>
          </Box>
          <Box pr={'16px'}>
            <Language variant="menuPrimary" />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Header;
